module.exports = __webpack_public_path__ + "static/media/veggi.a99c2d2c.jpg";